export default __webpack_public_path__ + "static/media/website_background.ede99cfa.mp4";